module.exports = __webpack_public_path__ + "img/3@2x.afcbdd79.png";